import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ASAP_LML } from "app/auth/baseAsapLml";

export const getListaPedidos = createAsyncThunk(
  "listaPedidosLMLApp/listaPedidosLML/getListaPedidos",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP_LML.get("/pedidos/LML", {
        params: params,
      });
    } catch (err: any) {
      console.error(err.response);
    }
    return response.data;
  }
);
